import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Box, CircularProgress, Container, useMediaQuery, useTheme, Grid,
  Stack,
} from "@mui/material";
import { Skeleton } from "@mui/material";

import SearchResultsComponent from "./SearchResultsComponent";
import HeroSection from "../../components/common/HeroSection";
import { getCourseFinderPage } from "../../services/CourseFinderPageService";

const CourseFinder = () => {
  const { country_id, country_name } = useSelector((state) => state.auth || {});
  const [loading, setLoading] = useState(true);
  const [programData, setProgramData] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (!country_id) return; // Wait until Redux has loaded country_id
    setLoading(true);

    const fetchProgramData = async () => {
      try {
        const res = await getCourseFinderPage(country_id);
        if (res?.data?.success && res?.data?.data) {
          setProgramData(res.data.data);
        } else {
          setProgramData(null);
        }
      } catch (err) {
        console.error("❌ Error fetching Study Program page:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProgramData();
  }, [country_id]);

  const getResponsiveHtml = (html) => {
    if (!html) return "";
    if (!isMobile) return html.replace(/<br\s*\/?>/gi, "").replace(/&nbsp;/gi, " ").replace(/\u00A0/gi, " ").replace(/\[empty_line\]/gi, "<br />");
    
    return html
      .replace(/font-size:\s*\d+px/gi, "font-size: 18px")
      .replace(/font-weight:\s*900/gi, "font-weight: 700")
      .replace(/<br\s*\/?>/gi, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/\u00A0/gi, " ")
      .replace(/\[empty_line\]/gi, "<br />");
  };

  if (loading) {
    return (
      <Container

        sx={{
          py: { xs: 3, sm: 4, md: 6 },
          px: { xs: 3, sm: 4, md: 6 },
        }}
      >
        <Grid container spacing={2} alignItems="center">

          {/* Left skeleton */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton variant="text" height={60} width="80%" />
            <Skeleton variant="text" height={30} width="90%" />
            <Skeleton variant="text" height={30} width="85%" />

            <Stack direction="row" spacing={2} mt={3}>
              <Skeleton variant="rounded" width={140} height={45} />
              <Skeleton variant="rounded" width={140} height={45} />
            </Stack>

            <Stack spacing={2} mt={3}>
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="75%" />
            </Stack>
          </Grid>

          {/* Right skeleton */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton
              variant="rectangular"
              height={420}
              sx={{ borderRadius: 2 }}
            />
          </Grid>

        </Grid>
      </Container>
    );
  }
  // if (loading)
  //   return (
  //     <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
  //       <CircularProgress color="warning" />
  //     </Box>
  //   );

  if (!programData)
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <p>
          No course finder data found for {country_name || "selected country"}.
        </p>
      </Box>
    );

  // ✅ Prepare data for components
  const heroTitle = programData.hero_section_title || "";
  const heroSubtitle = programData.hero_section_desc || "";
  const heroImageType = programData.hero_section_image_type || "image";
  const heroImage = programData.hero_section_image || "";
  const aboutDesc = programData.about_desc || "";

  return (
    <>
      {/* Hero Section */}
      <HeroSection
        titleContent={heroTitle}
        subtitleContent={heroSubtitle}
        // buttons={[
        //   { label: "Apply Now" },
        //   { label: "View & Download Brochure" },
        // ]}
        heroImage={heroImage}
        heroImageType={heroImageType}
      />

      <SearchResultsComponent />

      {aboutDesc && (
        <Container>
          <Box
            component="div"
            dangerouslySetInnerHTML={{ __html: getResponsiveHtml(aboutDesc) }}
            sx={{
              mt: 2,
              textAlign: { xs: "center", md: "center" },
              fontSize: { xs: "14px", md: "16px" },
              color: "text.secondary",
            }}
          />
        </Container>
      )}
    </>
  );
};

export default CourseFinder;
